<template>
  <div class="container-header">
    <div class="header-wrapper p-0">
      <div v-if="titleName" class="page-title-link">
        <router-link
          v-if="namePage == 'hotelTransport'"
          :to="{ name: titleLink, query: { secret: $route.query.secret, pax_voucher_id: paxVoucherId } }"
          class="logo-img"
        >
          <div class="back-to">
            <a class="row" href="javascript:void(0);">
              <i class="fa fa-chevron-left col-1"></i>
              <h1 class="col-10" style="text-transform: capitalize">{{ titleName }}</h1>
            </a>
          </div>
        </router-link>
        <router-link v-else :to="{ name: titleLink, query: query }" class="logo-img">
          <div class="back-to">
            <a class="row">
              <i class="fa fa-chevron-left"></i>
              <span class="col-10" style="text-transform: capitalize; font-weight: 400">{{ titleName }}</span>
            </a>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    titleName: {
      type: String,
      default: ''
    },
    titleLink: {
      type: String,
      default: ''
    },
    namePage: {
      type: String,
      default: ''
    },
    paxVoucherId: {
      type: [Number, String],
      default: ''
    },
    step: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      query: { secret: this.$route.query.secret }
    }
  },
  created() {
    if (!_.isUndefined(this.$route.query.token)) {
      this.query = { token: this.$route.query.token }
    }
  }
}
</script>
<style lang="scss" scoped>
.container-header {
  padding-top: 0.35rem;
  background-color: #f4f4f4;
  direction: ltr;
}
.page-title-link {
  background-color: white;
  padding-left: 1rem;
}
.back-to {
  display: flex;
  padding-left: 1.5rem !important;
  a {
    align-items: center;
    color: #474747;
    i {
      max-width: 1rem;
    }
    display: flex;
    width: 100%;
    h1 {
      color: #474747;
      white-space: nowrap;
    }
  }
}
</style>
